import React from "react";
import projectfour from "../assets/images/projectfour.jpg";

const ProjectFour = () => {
  return (
    <div className="card rounded-0 border-0 shadow-sm mb-5 mb-lg-0">
      <div className="card-img-container position-relative">
        <img
          className="card-img-top rounded-0 w-100"
          src={projectfour}
          alt=""
        />
        <div className="card-img-overlay">
          <div className="project-logo">
            <h4 className=" h-auto text-center">Expenditure Manager</h4>
          </div>
        </div>

        <a
          className="card-img-overlay-content text-start p-lg-4 text-white"
          href="https://expenditure-manager-mern.netlify.app/signin"
          target="_blank"
        >
          <h5>Expenditure Manager</h5>
          <p>
            A MERN Stack Web Application where users can record and track their
            Expenditures and can visualize Weekly, Monthly, Yearly Expenditure
            Data
          </p>
        </a>
      </div>

      <div className="card-body">
        <h5 className="text-center">
          <a
            href="https://expenditure-manager-mern.netlify.app/signin"
            rel="noreferrer"
            className="badge bg-light text-dark"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <i className="bi bi-cursor-fill mx-2" />
            Expenditure Manager
          </a>
        </h5>
        <h5 className="text-center">
          <a
            className="badge bg-light text-dark"
            href="https://github.com/Krish90s/expenditure-manager-project"
            rel="noreferrer"
            style={{ textDecoration: "none" }}
            target="_blank"
          >
            {" "}
            <i className="bi bi-github" /> Project GitHub Link
          </a>
        </h5>
      </div>
      <div className="card-footer border-0 text-center bg-white pb-4">
        <ul className="list-inline mb-0 mx-auto ">
          <li className="list-inline-item">
            <span className="badge bg-secondary badge-pill">React</span>
          </li>
          <li className="list-inline-item">
            <span className="badge bg-secondary badge-pill">Express</span>
          </li>
          <li className="list-inline-item">
            <span className="badge bg-secondary badge-pill">Node.js</span>
          </li>
          <li className="list-inline-item">
            <span className="badge bg-secondary badge-pill">MongoDB</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ProjectFour;
